import { render, staticRenderFns } from "./pg.vue?vue&type=template&id=d550e790&scoped=true"
import script from "./pg.vue?vue&type=script&lang=js"
export * from "./pg.vue?vue&type=script&lang=js"
import style0 from "./pg.vue?vue&type=style&index=0&id=d550e790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d550e790",
  null
  
)

export default component.exports